// XXX: ONE gap rule for completion cards, shared by the builder (the picker's
// XXX: Save refusal, the element's configurationProblems) and mirrored in PHP by
// XXX: src/Models/Studio/CompletionCardContextGaps.php for the compile gate.
// XXX: tests/unit/_support/completion-card-contexts/gap-cases.json holds both
// XXX: halves to the same answers and the same wording.
// XXX: Nothing is satisfied implicitly (task #125, Q2): a card's story context
// XXX: is a gap until the element binds it, even though the element has a story.
const { COMPLETION_COLUMNS, completionColumnFor } = require("./completion-picker-columns");

const FEED_SEPARATOR_CONTEXT_TYPE = "feedItemSeparator";

const ELEMENT_TYPE_LABELS = {
  CompletionStatus: "Completion Status",
  CompletionToggle: "Completion Toggle",
};

const COMPLETION_STATES = COMPLETION_COLUMNS.map(column => column.key);

function isPlainObject(value) {
  return Boolean(value) && typeof value === "object" && !Array.isArray(value);
}

function isBoundContext(binding) {
  if (typeof binding === "string") {
    return binding !== "";
  }
  if (!isPlainObject(binding)) {
    return false;
  }
  const hasEntitySource = typeof binding.entitySource === "string" && binding.entitySource !== "";
  const hasValueType = typeof binding.valueType === "string" && binding.valueType !== "";
  return hasEntitySource || hasValueType;
}

function requiredContextType(definition) {
  if (!isPlainObject(definition)) {
    return "";
  }
  return String(definition.entity ?? definition.entityType ?? definition.type ?? "");
}

function needsBinding(definition) {
  if (isPlainObject(definition) && Object.prototype.hasOwnProperty.call(definition, "default")) {
    return false;
  }
  return requiredContextType(definition) !== FEED_SEPARATOR_CONTEXT_TYPE;
}

function requiredContextsNeedingBinding(required) {
  return Object.fromEntries(Object.entries(isPlainObject(required) ? required : {})
      .filter(([, definition]) => needsBinding(definition)));
}

function unboundRequiredContexts(required, stateBindings) {
  const bindings = isPlainObject(stateBindings) ? stateBindings : {};
  return Object.entries(isPlainObject(required) ? required : {})
      .filter(([name, definition]) => needsBinding(definition) && !isBoundContext(bindings[name]))
      .map(([name, definition]) => ({ name, type: requiredContextType(definition) }));
}

function completionCardContextGaps({ elementId, elementType, cardIdsByState, bindingsByState, cardsById }) {
  const gaps = [];
  COMPLETION_STATES.forEach(state => {
    const cardId = Number(cardIdsByState?.[state]) || 0;
    const card = cardId > 0 ? cardsById?.[cardId] : null;
    if (!card || card.required === null || card.required === undefined) {
      return;
    }
    unboundRequiredContexts(card.required, bindingsByState?.[state]).forEach(({ name, type }) => {
      gaps.push({
        elementId,
        elementType,
        state,
        cardId,
        cardName: String(card.name ?? ""),
        contextName: name,
        contextType: type,
      });
    });
  });
  return gaps;
}

function describeCompletionCardContextGap(gap) {
  const elementLabel = ELEMENT_TYPE_LABELS[gap.elementType] ?? gap.elementType;
  const stateLabel = completionColumnFor(gap.state)?.label ?? gap.state;
  return `${elementLabel} ${gap.elementId}: the "${stateLabel}" card "${gap.cardName}" (#${gap.cardId}) `
    + `needs context "${gap.contextName}" (${gap.contextType}), which is not bound. `
    + "Bind it in the element's Components options.";
}

function completionCardContextGapsByState(gaps) {
  const byState = {};
  gaps.forEach(gap => {
    byState[gap.state] = [...byState[gap.state] ?? [], describeCompletionCardContextGap(gap)];
  });
  return byState;
}

module.exports = {
  COMPLETION_STATES,
  isBoundContext,
  requiredContextsNeedingBinding,
  unboundRequiredContexts,
  completionCardContextGaps,
  describeCompletionCardContextGap,
  completionCardContextGapsByState,
};
